export default "__VITE_ASSET__DKTkTisG__"